// extracted by mini-css-extract-plugin
module.exports = {"title":"accountDetails_title__9k9NZ","buttonGroup":"accountDetails_buttonGroup___EJN-"};